import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 4px;
	display: block;

	> a {
		font-family: ${helpers.font.family.header};
		color: ${helpers.color.textHeader};
	}
`
